export default "__VITE_ASSET__V3SfYkTS__"